import { IConnection } from "./connection";
import { ConnectionPool } from "./connection-pool";
import { getIframeOrigin } from "./helpers";
import { createPlainConnection } from "./plain-connection";
import { createTrustedConnection } from "./trusted-connection";

export interface IConnectionOptions {
  onReconnect?(): void;
}

export interface IIframeConnector {
  (iframe: HTMLIFrameElement, iframeUrl: string, opts?: IConnectionOptions): Promise<IConnection>;
}

export const createConnection: IIframeConnector = (
  iframe: HTMLIFrameElement,
  url: string,
  options?: IConnectionOptions
): Promise<IConnection> =>
  new Promise((resolve, reject) => {
    let canProceed = true;
    // FIXME: Fix this the next time the file is edited.
    // @ts-expect-error TS(6133): 'error' is declared but its value is never read.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
    const onConnectionError = (error: any): void => {
      if (canProceed) {
        canProceed = false;
        return;
      }
      reject(new Error(`Could not establish connection with the widget under ${url}`));
    };

    // Perform a race between two connections and see which one will resolve first.
    createTrustedConnection(iframe, options).then(resolve).catch(onConnectionError);

    createPlainConnection(iframe, getIframeOrigin(url)).then(resolve).catch(onConnectionError);
  });

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const destroyConnection = (connection: Promise<IConnection>, connectionPool: ConnectionPool) => {
  connection.then(connectionToDestroy => {
    if (!connectionToDestroy) {
      return;
    }

    connectionPool.remove(connectionToDestroy.connectionId);
    try {
      connectionToDestroy.destroy();
    } catch (err) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (err.code !== "DESTROYED") {
        throw err;
      }
    }
  });
};
